<template>
  <NuxtLink
    class=""
    :class="[
      $props.class,
      props?.disabled
        ? '!no-underline !cursor-auto'
        : 'ui-link'
    ]"
    :to="computedTo"
    :target="computedTarget"
    :data-active="computedIsActive"
    :title="computedTo"
    :prefetch="true"
    @click.capture="methodHandleClick"
    >
    <i
      v-if="computedLinkIcon && iconleft && !noicon"
      class="align-middle pb-[3px] text-[11px] pr-2"
      :class="[computedLinkIcon, classSvg]"
      />

    <slot />
    {{ text }}

    <i
      v-if="computedLinkIcon && !iconleft && !noicon"
      class="align-middle pb-[3px] text-[11px] pl-2"
      :class="[computedLinkIcon, classSvg]"
      />
  </NuxtLink>
</template>

<script setup lang="ts">
const localePath = useLocalePath()
const route = useRoute()

const props = defineProps<{
	to?: string|object|undefined|null
	href?: string|undefined
	target?: string
	class?: any
	text?: string
  iconleft?: boolean
  noicon?: boolean
  svg?: string
  classSvg?: string
  disabled?: boolean
}>()

const methodHandleClick = (event: PointerEvent) => {
  const from = window.location.pathname
  const to = computedTo.value

  if (props.disabled) {
    event.preventDefault()
    return
  }

  // if target is blank
  if (computedTarget.value?.includes('blank')) {
    event.preventDefault()
    window.open(computedTo.value, '_blank')
    return
  }

  // if from === to without #hashes
  if(typeof to === 'string' && (from === to || from.split('#')[0] === to.split('#')[0])) {
    event.preventDefault()
  }else{
    return
  }


  console.log('[link] scroll to element');
  // scroll to element
  document.getElementById(to.split('#')[1] as string)?.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  })

  // add to history
  window.history.pushState({ path: to }, '', to)
}

const computedTo = computed(() => {
  let to = props.to ?? props.href

  if(typeof to == 'string'){
    if (/^(https?:\/\/|mailto:|tel:)/.test(to)) return to

    if (to.startsWith('~')) {
      // to = window?.location?.pathname + to.slice(1)
      to = route.path + to.slice(1)
    }

    if (to.endsWith('/') && to !== '/') {
      to = to.slice(0, -1)
    }
  }

  if(!to){
    to = '/'
  }

  const hash = (typeof to == 'string' && to.includes('#'))
    ? '#'+to.split('#')[1]
    : ''

  const r = ((typeof to == 'string')
    ? localePath({
      path: to,
      hash: hash ?? ''
    })
    : localePath(to as any)
  ).toLowerCase()

  return r
})

const computedIsExternal = computed(() => {
  return computedTo.value !== undefined
		&& !computedTo.value.startsWith(window?.location?.origin)
		&& !computedTo.value.startsWith('/')
		&& !computedTo.value.startsWith('#')
})

const computedLinkIcon = computed(() => {
  if (props.svg) return props.svg

  if(computedTo.value.includes('tel:')) return 'fas fa-phone'
  if(computedTo.value.includes('mailto:')) return 'fas fa-envelope'
  if(computedIsExternal.value) return 'fas fa-external-link-alt'

  return '';
})

const computedIsActive = computed(() => {
  const to = computedTo.value
  const current = route.fullPath.replace(/\/$/, '')
  const target = to?.replace(/\/$/, '')

  return current === target
})

const computedTarget = computed(() => {
  return props.target ?? (computedIsExternal.value ? '_blank' : undefined)
});
</script>
